// extracted by mini-css-extract-plugin
module.exports = {"container":"localSettingToggle_container__Dno9g","header":"localSettingToggle_header__5hOnD"};